import { useState } from 'react';
import { Divider, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import useAuth from 'auth/useAuth';
import { getUserInitials } from 'auth/userDisplay';
import { useSettingsNav } from 'components/settingsHub/useSettingsNav';
import { FONT_MONO } from 'themes/tokens';
import { AvatarButton, AvatarDivider, MenuIdentity } from './UserMenu.styles';

type Props = {
  withDivider?: boolean;
};

const UserMenu = ({ withDivider = false }: Props) => {
  const { user, logout } = useAuth();
  const { open } = useSettingsNav();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  if (!user) return null;

  const close = () => setAnchorEl(null);

  return (
    <>
      {withDivider && <AvatarDivider orientation="vertical" />}
      <Tooltip title={user.display_name}>
        <AvatarButton
          type="button"
          aria-label="Open account menu"
          aria-haspopup="menu"
          aria-expanded={!!anchorEl}
          onClick={(event) => setAnchorEl(event.currentTarget)}
        >
          {getUserInitials(user)}
        </AvatarButton>
      </Tooltip>

      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={close} slotProps={{ paper: { sx: { borderRadius: 2 } } }}>
        <MenuIdentity>
          <Typography sx={{ fontWeight: 700 }} className="truncate">
            {user.display_name}
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ fontFamily: FONT_MONO }} className="truncate">
            {user.username}
          </Typography>
        </MenuIdentity>
        <Divider />
        <MenuItem
          onClick={() => {
            close();
            open('account');
          }}
        >
          <ListItemIcon>
            <ManageAccountsIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Account</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            close();
            void logout();
          }}
        >
          <ListItemIcon>
            <LogoutIcon fontSize="small" color="error" />
          </ListItemIcon>
          <ListItemText>Sign out</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserMenu;
